import { FormControl, FormGroup } from '@angular/forms';

export type AdminSubscriptionControls = {
  cardChargeDay: FormControl<number>;
};

export class AdminSubscriptionForm {
  public constructor(
    private readonly data: {
      cardChargeDay: number;
    },
  ) {}

  public get cardChargeDay(): number {
    return this.data.cardChargeDay;
  }
}

/* prettier-ignore */
export type AdminSubscriptionFormGroup = FormGroup<AdminSubscriptionControls>;
